import React from 'react';
import { ControlLink, Stack, Text } from '@moda/om';
import { PageMeta } from '../../components/PageMeta';
import { hrefFor } from '../../routers';

import './PrivacyEventPhotography.scss';

export const PrivacyEventPhotography = () => (
  <>
    <PageMeta title="Privacy Notice (Event Photography)" />
    <div className="PrivacyEventPhotography">
      <Stack space={1} className="PrivacyEventPhotography__title">
        <Text treatment="h3">Moda Operandi</Text>
        <Text treatment="h3">Privacy Notice (Event Photography)</Text>
      </Stack>

      <Stack space={4}>
        <Text treatment="body1">
          Moda Operandi, Inc. (together with our affiliates and subsidiaries, "Moda", "we", "us" or
          "our") created this Privacy Notice to inform you about how we use information we collect
          from you in the course of carrying out certain photography activities. This Privacy Notice
          relates to how we will use your personal information we collect for this purpose, which
          may include photo or video content we take of you (
          <Text treatment="bold1">"Photographs"</Text>) and related contact details such as your
          name, email address, and/or phone number and details of your agreement to use the
          Photographs (<Text treatment="bold1">"Contact Details"</Text>) (Photographs and Contact
          details referred to collectively herein as{' '}
          <Text treatment="bold1">“Event Information”</Text>). For more information about how we use
          the information we collect, including Event Information, please see{' '}
          <ControlLink className="PrivacyEventPhotography__link" to={hrefFor.PrivacyPolicyPage()}>
            Privacy Policy
          </ControlLink>
          .
        </Text>

        <Stack className="PrivacyEventPhotography__section" space={4}>
          <Text treatment="h5" className="PrivacyEventPhotography__header">
            How we will use Event Information
          </Text>
          <Text treatment="body1">
            We will only use Event Information when the law allows us to and in accordance with this
            Privacy Notice and our Privacy Policy. In particular, we will use Event Information:
          </Text>
          <Text treatment="body1">
            <ul className="PrivacyEventPhotography__list">
              <li>for the performance of a contract with you;</li>
              <li>for our legitimate interests (or those of a third party);</li>
              <li>to comply with legal or regulatory obligations; and/or</li>
              <li>where we have your consent.</li>
            </ul>
          </Text>
        </Stack>

        <Stack className="PrivacyEventPhotography__section" space={4}>
          <Text treatment="h5" className="PrivacyEventPhotography__header">
            Purposes for which we will use Event Information
          </Text>
          <Text treatment="body1">
            We may use Event Information for our internal purposes, and for commercial and marketing
            purposes on our owned or controlled websites (such as modaoperandi.com) and social media
            accounts (such as Instagram, Tik Tok, Facebook, and Pinterest), and in articles or
            press.
          </Text>
          <Text treatment="body1">
            We may also use your Contact Details for our internal record keeping, to contact you
            about Photographs where you are featured, and to comply with applicable law.
          </Text>
        </Stack>

        <Stack className="PrivacyEventPhotography__section" space={4}>
          <Text treatment="h5" className="PrivacyEventPhotography__header">
            Sharing Event Information
          </Text>
          <Text treatment="body1">
            We may share Event Information within the Moda group and to certain third parties such
            as our service providers and for press as permitted under our Privacy Policy. We may
            also share Event Information in the course of a corporate sale or other similar event.
          </Text>
        </Stack>

        <Stack className="PrivacyEventPhotography__section" space={4}>
          <Text
            treatment="h5"
            className=" PrivacyEventPhotography__header PrivacyEventPhotography__header-rights"
          >
            Your Rights
          </Text>
          <Text treatment="body1">
            As discussed further in our Privacy Policy, depending on your location, you may have the
            right to:
          </Text>
          <Text treatment="body1">
            <ul className="PrivacyEventPhotography__list">
              <li>request access to your information;</li>
              <li>request correction of your information;</li>
              <li>request erasure of your information;</li>
              <li>object to the processing of your information;</li>
              <li>request the restriction of processing of your information; and</li>
              <li>request the transfer of your information to another party.</li>
            </ul>
          </Text>
        </Stack>

        <Stack className="PrivacyEventPhotography__section" space={4}>
          <Text treatment="body1">
            If you would like to seek to exercise any of these rights, please contact us.
          </Text>
          <Text treatment="body1">
            If you have any questions or concerns about our use of Event Information or any other
            information we may have about you, then please contact us.
          </Text>
        </Stack>
      </Stack>
    </div>
  </>
);
